import { render, staticRenderFns } from "./ProductInfoModal.vue?vue&type=template&id=552d8c8b"
import script from "./ProductInfoModal.vue?vue&type=script&lang=js"
export * from "./ProductInfoModal.vue?vue&type=script&lang=js"
import style0 from "./ProductInfoModal.vue?vue&type=style&index=0&id=552d8c8b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports